// extracted by mini-css-extract-plugin
export default {"root":"Button_contact_root__AXfFl","buttonText":"Button_contact_buttonText__E5P4h","IconMail":"Button_contact_IconMail__zuMkV"};